import { cn } from '@/lib/utils';
import 'material-symbols';

export interface VideoPlayIconProps {
    className?: string;
}

// Filled because the Material Symbols default outline reads as a second triangle at this size.
export const VideoPlayIcon = ({ className }: VideoPlayIconProps) => (
    <span
        className={cn(
            'material-symbols-rounded text-white drop-shadow-md',
            '[font-variation-settings:\'FILL\'_1]',
            className,
        )}
        aria-hidden
    >
        play_arrow
    </span>
);
